var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflinestep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_198_20360_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.96 17.4873C21.1998 17.3615 21.4867 17.3616 21.7266 17.4873C22.6341 17.9635 23.6594 18.2226 24.6865 18.2227C25.5261 18.2227 26.3552 18.0554 27.1182 17.7412C27.6301 17.5303 28.2773 17.8718 28.2773 18.4814V24C28.2773 26.3623 26.3623 28.2773 24 28.2773H12C9.63769 28.2773 7.72266 26.3623 7.72266 24V18.4814C7.72266 17.8718 8.36987 17.5303 8.88184 17.7412C9.64479 18.0554 10.474 18.2227 11.3135 18.2227C12.3406 18.2226 13.3659 17.9635 14.2734 17.4873C14.5133 17.3616 14.8002 17.3615 15.04 17.4873C15.9476 17.9635 16.9728 18.2227 18 18.2227C19.0272 18.2227 20.0524 17.9635 20.96 17.4873ZM18 21.2773C16.4963 21.2773 15.2773 22.4963 15.2773 24V25.7227H20.7227V24C20.7227 22.4963 19.5037 21.2773 18 21.2773ZM25.8711 7.72266C26.7814 7.72277 27.6043 8.26454 27.9639 9.10059L28.9648 11.4287C29.1656 11.8956 29.3926 12.6103 29.21 13.4004C28.7434 15.4173 26.8181 16.7772 24.6904 16.7773C23.4142 16.7773 22.2065 16.2826 21.3447 15.4531C20.483 16.2824 19.2761 16.7773 18 16.7773C16.7237 16.7773 15.5161 16.2827 14.6543 15.4531C13.7925 16.2823 12.5855 16.7773 11.3096 16.7773C9.18187 16.7772 7.25665 15.4173 6.79004 13.4004C6.60736 12.6103 6.83439 11.8956 7.03516 11.4287L8.03613 9.10059C8.39571 8.26454 9.21861 7.72277 10.1289 7.72266H25.8711Z",
    fill: "url(#paint0_linear_198_20360)",
    stroke: "#141C2A",
    strokeWidth: 0.554666
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_198_20360_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_20360",
    x1: 18,
    y1: 8,
    x2: 18,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2D12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflinestep1);
export default __webpack_public_path__ + "static/media/offlinestep1.4ea6fd332d322bf14b0227de5ce0451d.svg";
export { ForwardRef as ReactComponent };